import { useTranslation } from 'react-i18next';
import { ViewComponentProps } from '../../../common';
import { phoneNumberParse } from '../../../helpers/utils';
import { InvitationRecipientType } from '../../types';
import { SummaryViewTitle } from '../widgets';

type InvitationRecipientsViewProps = ViewComponentProps & {
  invitationRecipients: InvitationRecipientType[];
  showEditIcon?: boolean;
};

const InvitationRecipientsView: React.FC<InvitationRecipientsViewProps> = ({
  title,
  invitationRecipients,
  hasTitle = true,
  showEditIcon = true,
}) => {
  const { t } = useTranslation();
  const viewTitle = hasTitle ? t(title || 'enrollments.invitationRecipientsViewTitle') : '';

  return (
    <div className="schedule-form" data-testid="ir-view">
      <SummaryViewTitle title={viewTitle} showEditIcon={showEditIcon} />
      {invitationRecipients.map((invitationRecipient) => (
        <div key={invitationRecipient.contactId} className="invitation-recipient ws-view-form">
          <div className="row">
            <label>{t('common.name')}</label>
            <div className="value font-bold">{invitationRecipient.displayName}</div>
          </div>
          <div className="row">
            <label>{t('common.email')}</label>
            <div className="value">{invitationRecipient.email}</div>
          </div>
          <div className="row">
            <label>{t('common.phone')}</label>
            <div className="value">{phoneNumberParse(invitationRecipient.phone) || t('common.notAvailable')}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default InvitationRecipientsView;
